import { Component, OnInit, Input,Output, EventEmitter, } from '@angular/core';

@Component({
    selector: 'app-patient-support',
    templateUrl: './patient-support.component.html',
    styleUrls: ['./patient-support.component.scss'],
    standalone: false
})
export class PatientSupportComponent implements OnInit {
  
  @Input() close: string;
  @Input() messageh3: string;
  @Input() messagep: string;
  @Input() path: string;
  @Output() buttonWasClicked = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
   
  }

  hidepopup(){
    this.buttonWasClicked.emit();
  }
 

}
